import { render, staticRenderFns } from "./MyTable.vue?vue&type=template&id=bca00864&scoped=true&"
import script from "./MyTable.vue?vue&type=script&lang=js&"
export * from "./MyTable.vue?vue&type=script&lang=js&"
import style0 from "./MyTable.vue?vue&type=style&index=0&id=bca00864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca00864",
  null
  
)

export default component.exports